import _ from 'lodash';

const isOptions = options =>
  _.isPlainObject(options) && ('startDate' in options || 'endDate' in options);

export default function getAffectedAggregateIds(invokeFunction) {
  return (aggregateTypenames, options) => {
    // support for previous signature
    if (!isOptions(options)) {
      options = { startDate: options };
    }

    const { startDate, endDate } = options;

    if (endDate != null && startDate == null) {
      throw new Error('must provide a startDate when providing an endDate');
    }

    return invokeFunction('affected-aggregateids', { aggregateTypenames, startDate, endDate });
  };
}
